import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonFeatureToggleModule } from '@capital-access/common/feature-toggle';
import { CommonFormattingModule } from '@capital-access/common/formatting';
import { CommonLocalizationModule } from '@capital-access/common/localization';
import { FireflyPopoverModule } from '@capital-access/firefly/components';
import { ProfilesComponentsCommonModule } from '@capital-access/profiles/components-common';
import { BestFundIconComponent } from './components/best-fund-badge/best-fund-icon.component';
import { CaManagedByComponent } from './components/ca-managed-by/ca-managed-by.component';
import { InstitutionRatingComponent } from './components/institution-rating/institution-rating.component';
import { NotTargetedInfoPopoverComponent } from './components/not-targeted-info-popover/not-targeted-info-popover.component';
import { PurchasingPowerBadgeComponent } from './components/purchasing-power-badge/purchasing-power-badge.component';
import { SurveillanceDataInfoComponent } from './components/surveillance-data-info/surveillance-data-info.component';
import { SurveillancePopoverComponent } from './components/surveillance-popover/surveillance-popover.component';
import { TARGETING_COMMON_KEY } from './constants';
import { TargetingRepository } from './services/targeting.repository';
import { TargetingExportRepository } from './services/targeting-export.repository';
import { TargetingScoreboardRepository } from './services/targeting-scoreboard.repository';

@NgModule({
  imports: [
    CommonModule,
    CommonFormattingModule,
    CommonFeatureToggleModule,
    CommonLocalizationModule.forFeature(TARGETING_COMMON_KEY),
    FireflyPopoverModule,
    ProfilesComponentsCommonModule
  ],
  declarations: [
    PurchasingPowerBadgeComponent,
    InstitutionRatingComponent,
    BestFundIconComponent,
    SurveillanceDataInfoComponent,
    SurveillancePopoverComponent,
    NotTargetedInfoPopoverComponent,
    CaManagedByComponent
  ],
  providers: [TargetingScoreboardRepository, TargetingRepository, TargetingExportRepository],
  exports: [
    PurchasingPowerBadgeComponent,
    InstitutionRatingComponent,
    BestFundIconComponent,
    SurveillanceDataInfoComponent,
    SurveillancePopoverComponent,
    NotTargetedInfoPopoverComponent,
    CaManagedByComponent
  ]
})
export class TargetingCommonModule {}
